/** Columnas visibles en facturas SHIPPING cuando el equipo es tenant_external (orden de visualización). */
export const TENANT_EXTERNAL_SHIPPING_TABLE_FIELDS = [
  'ref',
  'shop',
  'payment_method',
  'order_total',
  'processed_at',
  'type',
  'courier',
  'tracking_number',
  'country',
  'zip',
  'weight_internal_kg',
  'shipping_base',
  'preparation_base',
  'cod_base',
  'total',
] as const;

export type TenantExternalShippingTableField = (typeof TENANT_EXTERNAL_SHIPPING_TABLE_FIELDS)[number];
